import ApiService from '@/services/ApiService.js'
import store from '@/store/store'

export const namespaced = true
export const state = {
  colorObj: '',
  colorObjForNewDesign: {
    title: 'Default',
    topNavBg: '#fff',
    topNavTextColor: '#98C1D9',
    leftSidebarBg: '#3D5A80',
    sidebarHighlightBg: '#98C1D9',
    sidebarTextColor: '#CECECE',
    sidebarActiveTextColor: '#ffffff',
    contentBg: '#293241',
    contentCardHeaderBg: '#98C1D9',
    commonBtnColor: '#3d5a80',
    filterSelectionBg: null,
    filterTextColor: '#ffffff'
  },
  font: '',
  logo: '',
  isCircleLogo: false,
  logoPadding: [0, 0, 0, 0],
  loginBg: '',
  topNavBg: '',
  topNavBgOpacity: 1,
  menuBg: '',
  menuBgOpacity: 1,
  mainContentBg: '',
  mainContentBgOpacity: 1,
  fontSize: {
    mainTitle: 26,
    title: 18,
    smallTitle: 17,
    bodyText: 16,
    bodyTextSmall: 14,
    supplementaryText: 13
  },
  fontColor: {
    primaryText: '#000000',
    regularText: '#333333',
    secondaryText: '#555555',
    placeholderText: '#c0c4cc'
  },
  isTimeDisplayEnabled: false
}

export const getters = {
  // If the user-defined logo is set, the user-defined logo is used; otherwise, the default logo is used
  logo: state => {
    let logo = state.logo
    if (!logo) logo = require('@/assets/image/smartz-logo-black.svg')
    return logo
  },
  // If the user-defined login background is set, the user-defined login background is used; otherwise, the default login background is used
  loginBg: state => {
    let loginBg = state.loginBg
    if (!loginBg) loginBg = require('@/assets/image/login-bg.jpeg')
    return loginBg
  }
}

export const mutations = {
  SET_COLOR_OBG(state, colorObj) {
    state.colorObj = colorObj
  },
  SET_COLOR_OBG_FOR_NEW_DESIGN(state, colorObj) {
    state.colorObjForNewDesign = colorObj
  },
  SET_FONT(state, font) {
    state.font = font
  },
  SET_LOGO(state, logo) {
    state.logo = logo
  },
  SET_IS_CIRCLE_LOGO(state, isCircleLogo) {
    state.isCircleLogo = isCircleLogo
  },
  SET_LOGO_PADDING(state, padding) {
    state.logoPadding = padding
  },
  SET_LOGIN_BG(state, loginBg) {
    state.loginBg = loginBg
  },
  SET_TOP_NAV_BG(state, topNavBg) {
    state.topNavBg = topNavBg
  },
  SET_TOP_NAV_BG_OPACITY(state, topNavBgOpacity) {
    state.topNavBgOpacity = topNavBgOpacity
  },
  SET_MENU_BG(state, menuBg) {
    state.menuBg = menuBg
  },
  SET_MENU_BG_OPACITY(state, menuBgOpacity) {
    state.menuBgOpacity = menuBgOpacity
  },
  SET_MAIN_CONTENT_BG(state, mainContentBg) {
    state.mainContentBg = mainContentBg
  },
  SET_MAIN_CONTENT_BG_OPACITY(state, mainContentBgOpacity) {
    state.mainContentBgOpacity = mainContentBgOpacity
  },
  SET_FONT_SIZE(state, fontSize) {
    state.fontSize = fontSize
  },
  SET_FONT_COLOR(state, fontColor) {
    state.fontColor = fontColor
  },
  SET_IS_TIME_DISPLAY_ENBLED: (state, data) => {
    state.isTimeDisplayEnabled = data
  }
}

export const actions = {
  applyColorForNewDesign({ commit }, selectedColor) {
    let style = document.getElementsByTagName('body')[0].style
    style.setProperty('--newThemeTopNavBg', selectedColor.topNavBg)
    style.setProperty(
      '--newThemeTopNavTextColor',
      selectedColor.topNavTextColor
    )
    style.setProperty(
      '--newThemeTopNavActiveTextColor',
      selectedColor.topNavActiveTextColor
    )
    style.setProperty('--newThemeSidebarBg', selectedColor.leftSidebarBg)
    style.setProperty(
      '--newThemeSidebarHightlightBg',
      selectedColor.sidebarHighlightBg
    )
    style.setProperty(
      '--newThemeSidebarTextColor',
      selectedColor.sidebarTextColor
    )
    style.setProperty(
      '--newThemeSidebarActiveTextColor',
      selectedColor.sidebarActiveTextColor
    )
    style.setProperty('--newThemeContentBg', selectedColor.contentBg)
    style.setProperty(
      '--newThemeContentCardHeaderBg',
      selectedColor.contentCardHeaderBg
    )
    style.setProperty(
      '--newThemeContentCardTitleTextColor',
      selectedColor.contentCardHeaderTextColor || '#ffffff'
    )
    style.setProperty(
      '--newThemeContentCardBodyBg',
      selectedColor.contentCardBodyBg
    )
    style.setProperty(
      '--newThemeLoadingBg',
      hexToRGBA(selectedColor.contentCardBodyBg, 0.9)
    )
    style.setProperty(
      '--newThemeQuickActionBg',
      hexToRGBA(selectedColor.contentCardHeaderBg, 0.1)
    )
    style.setProperty(
      '--newThemeFilterSelectionBg',
      selectedColor.filterSelectionBg || 'transparent'
    )
    style.setProperty(
      '--newThemeFilterTextColor',
      selectedColor.filterTextColor || '#ffffff'
    )
    style.setProperty(
      '--newThemeFilterLabelColor',
      selectedColor.filterLabelColor || '#ffffff'
    )
    style.setProperty(
      '--newThemeTeamSupportModuleTextColor',
      selectedColor.teamSupportModuleTextColor || '#43A3CC'
    )
    style.setProperty(
      '--newThemeQuickActionIconColor',
      selectedColor.quickActionIconColor || '#2e7d32'
    )
    style.setProperty('--newThemeCommonBtnBg', selectedColor.commonBtnColor)
    let colors = [
      selectedColor.leftSidebarBg,
      selectedColor.sidebarHighlightBg,
      selectedColor.contentCardHeaderBg
    ]
    colors = colors
      .map(color => hexToRGBA(color, 1))
      .sort((a, b) => getLightness(b) - getLightness(a))
    style.setProperty('--newThemeSliderColor1', colors[0])
    style.setProperty('--newThemeSliderColor2', colors[1])
    style.setProperty('--newThemeSliderColor3', colors[2])

    commit('SET_COLOR_OBG_FOR_NEW_DESIGN', selectedColor)
  },
  applyFont({ commit }, font) {
    var url = getDownloadURL(font, ['regular'], false) // Add the stylesheet to the document head
    var link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = url

    document.head.appendChild(link)
    document
      .getElementsByTagName('body')[0]
      .style.setProperty('--fontFamily', font)
    commit('SET_FONT', font)
  },
  applyTopNavBg({ commit }, data) {
    if (data.bg) {
      let style = document.getElementsByTagName('body')[0].style
      style.setProperty(
        '--newThemeTopNavBg',
        hexToRGBA(
          store.state.customization.colorObjForNewDesign.topNavBg,
          data.opacity
        )
      )
    }
    commit('SET_TOP_NAV_BG', data.bg)
    commit('SET_TOP_NAV_BG_OPACITY', data.opacity)
  },
  applyMenuBg({ commit }, data) {
    if (data.bg) {
      let style = document.getElementsByTagName('body')[0].style
      style.setProperty(
        '--newThemeSidebarBg',
        hexToRGBA(
          store.state.customization.colorObjForNewDesign.leftSidebarBg,
          data.opacity
        )
      )
      style.setProperty(
        '--newThemeSidebarHightlightBg',
        hexToRGBA(
          store.state.customization.colorObjForNewDesign.sidebarHighlightBg,
          data.opacity
        )
      )
    }
    commit('SET_MENU_BG', data.bg)
    commit('SET_MENU_BG_OPACITY', data.opacity)
  },
  applyMainContentBg({ commit }, data) {
    if (data.bg) {
      let style = document.getElementsByTagName('body')[0].style
      style.setProperty(
        '--newThemeContentBg',
        hexToRGBA(store.state.customization.colorObjForNewDesign.contentBg, 0)
      )
      style.setProperty(
        '--newThemeContentCardHeaderBg',
        hexToRGBA(
          store.state.customization.colorObjForNewDesign.contentCardHeaderBg,
          data.opacity
        )
      )
      style.setProperty(
        '--newThemeContentCardBodyBg',
        hexToRGBA(
          store.state.customization.colorObjForNewDesign.contentCardBodyBg,
          data.opacity
        )
      )
    }
    commit('SET_MAIN_CONTENT_BG', data.bg)
    commit('SET_MAIN_CONTENT_BG_OPACITY', data.opacity)
  },
  applyFontSize({ commit }, data) {
    let style = document.getElementsByTagName('body')[0].style
    style.setProperty('--newThemeMainTitleSize', data.mainTitle + 'px')
    style.setProperty('--newThemeTitleSize', data.title + 'px')
    style.setProperty('--newThemeSmallTitleSize', data.smallTitle + 'px')
    style.setProperty('--newThemeBodyTextSize', data.bodyText + 'px')
    style.setProperty('--newThemeBodyTextSmallSize', data.bodyTextSmall + 'px')
    style.setProperty(
      '--newThemeSupplementaryTextSize',
      data.supplementaryText + 'px'
    )
    commit('SET_FONT_SIZE', data)
  },
  applyFontColor({ commit }, data) {
    let style = document.getElementsByTagName('body')[0].style
    style.setProperty('--newThemePrimaryTextColor', data.primaryText)
    style.setProperty('--newThemeRegularTextColor', data.regularText)
    style.setProperty('--newThemeSecondaryTextColor', data.secondaryText)
    style.setProperty('--newThemePlaceholderTextColor', data.placeholderText)
    commit('SET_FONT_COLOR', data)
  },
  getCustomTheme({ commit }) {
    let user = localStorage.getItem('user')
    if (!user) {
      return Promise.resolve()
    }
    user = JSON.parse(user)
    let selectedOrganisation = user.organisations.filter(item => item.Active)
    selectedOrganisation = selectedOrganisation.length
      ? selectedOrganisation[0]
      : null
    let orgId = selectedOrganisation
      ? selectedOrganisation.OrganisationName.OrganisationId
      : null
    if (!orgId) {
      return Promise.resolve()
    }
    return ApiService.GetOrganisationSettings(orgId)
      .then(response => {
        if (response.data.success) {
          let isTimeDisplayEnabled = response.data.data.IsTimeDisplayEnabled
          commit('SET_IS_TIME_DISPLAY_ENBLED', isTimeDisplayEnabled)

          let themeValue = response.data.data.ThemeValue
          if (!themeValue) return false
          themeValue = JSON.parse(themeValue)
          store.dispatch('customization/applyFont', themeValue.font)
          commit('SET_LOGO', themeValue.logo)
          commit('SET_IS_CIRCLE_LOGO', !!themeValue.isCircleLogo)
          commit('SET_LOGO_PADDING', themeValue.logoPadding || [0, 0, 0, 0])
          commit('SET_LOGIN_BG', themeValue.loginBg || null)

          store.dispatch(
            'customization/applyColorForNewDesign',
            themeValue.colors
          )
          store.dispatch('customization/applyTopNavBg', {
            bg: themeValue.topNavBg || null,
            opacity: themeValue.topNavBgOpacity || 0
          })
          store.dispatch('customization/applyMenuBg', {
            bg: themeValue.menuBg || null,
            opacity: themeValue.menuBgOpacity || 1
          })
          store.dispatch('customization/applyMainContentBg', {
            bg: themeValue.mainContentBg || null,
            opacity: themeValue.mainContentBgOpacity || 1
          })
          store.dispatch('customization/applyFontSize', themeValue.fontSize)
          store.dispatch('customization/applyFontColor', themeValue.fontColor)
        }
      })
      .catch(() => {
        //console.log('IN Catch: ')
      })
  }
}

function hexToRGBA(color, opacity) {
  let sColor = color.toLowerCase()
  // Regular expression for hexadecimal color values
  const regType1 = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
  const regType2 = /(\d(\.\d+)?)+/g
  // If it is a hexadecimal color
  if (sColor && regType1.test(sColor)) {
    if (sColor.length === 4) {
      let sColorNew = '#'
      for (let i = 1; i < 4; i += 1) {
        sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1))
      }
      sColor = sColorNew
    }
    // Process six digit color values
    const sColorChange = []
    for (let i = 1; i < 7; i += 2) {
      sColorChange.push(parseInt('0x' + sColor.slice(i, i + 2)))
    }
    return 'rgba(' + sColorChange.join(',') + ',' + opacity + ')'
  } else if (color.match(regType2)) {
    // If it is in RGB format
    let val = color.match(regType2)
    val.splice(val.length - 1, 1, opacity)
    return 'rgba(' + val.join(',') + ')'
  }
  return sColor
}

function getLightness(color) {
  let rgb = color.match(/\d+/g).map(Number)
  // Using the Perceived Brightness Formula: (R * 299 + G * 587 + B * 114) / 1000
  return (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000
}

function getDownloadURL(font, variants, onlyCharacters = true) {
  // Base URL
  var url = 'https://fonts.googleapis.com/css?family=' // Font name

  url += font.replace(/ /g, '+') // Font variants

  url += ':'.concat(variants[0])

  for (var i = 1; i < variants.length; i += 1) {
    url += ','.concat(variants[i])
  } // Only download characters in the font name if onlyCharacters is true

  if (onlyCharacters === true) {
    // Remove spaces and duplicate letters from the font name
    var downloadChars = font.family
    downloadChars = downloadChars.replace(/\s+/g, '')
    downloadChars = downloadChars
      .split('')
      .filter(function(x, n, s) {
        return s.indexOf(x) === n
      })
      .join('')
    url += '&text='.concat(downloadChars)
  }

  return url
}
